let selectedPipelineHistoryInputs = [
    {
        id: 'result',
        label: 'Params',
        type: 'textarea',
        placeholder: 'Params',
        dataPath: 'result'
    }
]

export { selectedPipelineHistoryInputs }